import "./utils/dayjs";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "tippy.js/dist/tippy.css";
import "tippy.js/animations/shift-away.css";
import * as Sentry from "@sentry/react";

Sentry.init({
    dsn: "https://bca297479c3e01ab57bd6a4f08264278@o4508014975844352.ingest.us.sentry.io/4509282591506434",
    sendDefaultPii: true,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    environment: import.meta.env.NODE_ENV,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});

createRoot(document.getElementById("root")!).render(<App />);
